export default "__VITE_ASSET__9UzyWgyD__"